module.exports = __webpack_public_path__ + "files/835f8a40d5260565d640f124122b232a.png";